import { RoleType } from '@features/team-management/constants';

// eslint-disable-next-line import/prefer-default-export
export const UserTypes = {
  ADMIN: 'admin',
  USER: 'user'
};

export const LEAD_MANAGEMENT_ROLES = [
  RoleType.SALES_AGENT,
  RoleType.SALES_MANAGER
];
